import dayjs from 'dayjs';
export const formatDate = (date, format) => {
    return dayjs(date).format(format);
};
/**
 * Formats a date string to a readable format (e.g., "Feb 26, 2019")
 * @param dateString - Date string in ISO format or any valid date string
 * @returns Formatted date string or original string if parsing fails
 */
export const formatDateReadable = (dateString) => {
    try {
        return dayjs(dateString).format('MMM D, YYYY');
    }
    catch {
        return dateString;
    }
};
